var Map = (function(){
    'use strict';

    var centerMap = [4.86,45.76];
    var map = null;
    var defaultZoom = 11;
    var minZoom = 5;

    var bounds = null;

    var onFullscreenChange = function() {
        map.resize();
    };

    var overrideFullscreenLabel = function(){
        var fullscreenElement = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement;

        if(fullscreenElement) {
            if($('.maplibregl-ctrl-shrink').length > 0) {
                $('.maplibregl-ctrl-shrink').attr('title', "Réduire");
                $('.maplibregl-ctrl-shrink').attr('aria-label', "Réduire");
            }
        }
        else {
            if($('.maplibregl-ctrl-fullscreen').length > 0) {
                $('.maplibregl-ctrl-fullscreen').attr('title', "Agrandir");
                $('.maplibregl-ctrl-fullscreen').attr('aria-label', "Agrandir");
            }
        }
    };

    var loadLayer = function(map, uniqId){
        var tstamp = + Date.now();
        var sourceName = "commune" + tstamp;

        // Disable warning: Eval can be harmful
        /*jshint -W061 */
        map.addSource(sourceName, {
            type: "geojson",
            data: eval('communes_' + uniqId)
        });

        map.addLayer({
            'id': 'communes' + tstamp,
            "type": "line",
            "source": sourceName,
            "paint": {
                "line-color": '#cb1c39',
                "line-width" : 2
            },
            "filter": ["==", "$type", "Polygon"]
        });

        map.addLayer({
            'id': 'communes-fill' + tstamp,
            "type": "fill",
            "source": sourceName,
            "paint": {
                'fill-color': '#ddd',
                'fill-opacity': 0.3
            },
            "filter": ["==", "$type", "Polygon"]
        });
    };

    return {
        resize: function () { map.resize(); },
        init: function(idMapCss, uniqId) {

            map = new maplibregl.Map({
                container: idMapCss,
                style: 'https://api.maptiler.com/maps/2fd5d730-6acc-458e-ab0a-e019b30eba43/style.json?key=Kww0l0Dgu3PY1uyqjxxP',
                center: centerMap,
                zoom: defaultZoom,
                minZoom: minZoom,
                attributionControl: true
            });
            // Disable warning: Eval can be harmful
            /*jshint -W061 */
            var boundsArray = eval("boundsArray_" + uniqId);
            if(boundsArray !== null && boundsArray.length > 0) {
                bounds = new maplibregl.LngLatBounds(boundsArray[0][0], boundsArray[0][0]);
                var length1 = boundsArray.length;
                for(var i=0; i < length1; i++) {
                    var length2 = boundsArray[i].length;

                    for(var j=0; j < length2; j++) {
                        bounds.extend(boundsArray[i][j]);
                    }
                }

                map.fitBounds(bounds, {
                    padding: 20
                });
            }

            map.on('load', function() {

                this.addControl(new maplibregl.NavigationControl({showCompass:true}), 'bottom-right');
                this.addControl(new maplibregl.FullscreenControl(), 'bottom-right');

                 setTimeout(function(){
                    if ($('html').attr('lang') === 'fr-FR') {

                        if(document.querySelector('.maplibregl-ctrl-attrib-inner')) {
                            var text = $('.maplibregl-ctrl-attrib-inner').html();
                            var textReplace = text.replace('© OpenStreetMap contributors', '© Contributeurs de OpenStreetMap');
                            $('.maplibregl-ctrl-attrib-inner').html(textReplace);
                        }

                        if(document.querySelector('.maplibregl-ctrl-zoom-in')) {
                            document.querySelector('.maplibregl-ctrl-zoom-in').setAttribute('title', 'Zoom avant');
                            document.querySelector('.maplibregl-ctrl-zoom-in').setAttribute('aria-label', 'Zoom avant');
                        }
                        if(document.querySelector('.maplibregl-ctrl-zoom-out')) {
                            document.querySelector('.maplibregl-ctrl-zoom-out').setAttribute('title', 'Zoom arrière');
                            document.querySelector('.maplibregl-ctrl-zoom-out').setAttribute('aria-label', 'Zoom arrière');
                        }

                        if(document.querySelector('.maplibregl-ctrl-compass-arrow')) {
                            document.querySelector('.maplibregl-ctrl-compass-arrow').setAttribute('title', 'Réinitialisation au Nord');
                            document.querySelector('.maplibregl-ctrl-compass-arrow').setAttribute('aria-label', 'Réinitialisation au Nord');
                        }
                        if(document.querySelector('.maplibregl-ctrl-fullscreen')) {
                            document.querySelector('.maplibregl-ctrl-fullscreen').setAttribute('title', 'Agrandir');
                            document.querySelector('.maplibregl-ctrl-fullscreen').setAttribute('aria-label', 'Agrandir');
                        }

                        document.addEventListener("fullscreenchange", overrideFullscreenLabel);
                        document.addEventListener("mozfullscreenchange", overrideFullscreenLabel);
                        document.addEventListener("webkitfullscreenchange", overrideFullscreenLabel);
                        document.addEventListener("msfullscreenchange", overrideFullscreenLabel);
                    }
                },100);

                loadLayer(this, uniqId);
            });

            var fullScreenChange='';
            if ('onfullscreenchange' in window.document) {
                fullScreenChange = 'fullscreenchange';
            } else if ('onmozfullscreenchange' in window.document) {
                fullScreenChange = 'mozfullscreenchange';
            } else if ('onwebkitfullscreenchange' in window.document) {
                fullScreenChange = 'webkitfullscreenchange';
            } else if ('onmsfullscreenchange' in window.document) {
                fullScreenChange = 'MSFullscreenChange';
            }

            window.document.addEventListener(fullScreenChange, onFullscreenChange);
        }
    };

}());

$(document).ready(function(){
    if($(".mapdiv").length > 0) {
        $('.mapdiv').each(function(){
            var id = $(this).attr('id');
            var uniqId = $(this).data('uniqueid');

            Map.init(id, uniqId);
        });
    }
});
